const FeedbackLoader = require('client/feedbackLoader');

const t = require('engine/i18n/t');

t.i18n.add('courses', require('courses/locales/' + LANG + '.yml'));

module.exports = function() {
  if (!window.FEEDBACK_LIST_INIT) return;
  const loader = new FeedbackLoader(window.FEEDBACK_LIST_INIT);

  const profileFeedback = document.querySelector('.profile-feedback');
  for (let stat of document.querySelectorAll('.feedback-stat')) {
    stat.addEventListener('click', e => {
      const starItem = e.target.closest('.feedback-stat__item_clickable');
      if (starItem) {
        profileFeedback.scrollIntoView(true);
        const stars = starItem.getAttribute('data-stars');
        const course = starItem.closest('.course-stats').getAttribute('data-course');
        loader.applyFilter({ stars, course });
      }
    })
  }

  for (let link of document.querySelectorAll('.course-stats__feedback-link')) {
    link.addEventListener('click', e => {
      e.preventDefault();
      profileFeedback.scrollIntoView(true);
      const course = link.closest('.course-stats').getAttribute('data-course');
      loader.applyFilter({ course });
    });
  }

  loader.elem.addEventListener('feedbackChange', () => {
    const course = loader.filter.course;
    const stars = loader.filter.stars;

    const activeStarsElem = document.querySelector(`[data-stars].feedback-stat__item_active`);
    if (activeStarsElem) activeStarsElem.classList.remove('feedback-stat__item_active');

    if (loader.filter.stars) {
      const activeStatElem = document.querySelector(`.course-stats[data-course='${course}'] [data-stars='${stars}']`);
      if (activeStatElem) activeStatElem.classList.add('feedback-stat__item_active');
    }
  })
};
